type ApiEnvironments = "PROD" | "DEV" | "STAGE";

const projectEnv: ApiEnvironments = "PROD";

const getApiUrl = (env: ApiEnvironments): string => {
  switch (env) {
    case "PROD":
      return process.env.REACT_APP_API_PROD_BASE_URL || "";
    case "DEV":
      return process.env.REACT_APP_API_DEV_BASE_URL || "";
    case "STAGE":
      return process.env.REACT_APP_API_STAGE_BASE_URL || "";
    default:
      throw new Error("Unknown environment: " + env);
  }
};

export const api_url = getApiUrl(projectEnv);
export const token = localStorage.getItem("token");

export const logout = (): void => {
  localStorage.removeItem("token");
  window.location.href = "/login";
};
